import request from "@/utils/request";  //导入封装请求的js文件

//注册列表
export function getRegisterList (data) {
  return request({
    url: '/copyrightApi/reg/auth/v2/cr/reg/list',
    method: 'post',
    data: data,
  })
}
//著作权信息采集
export function insertRagister (data) {
  return request({
    url: '/copyrightApi/reg/auth/v2/info/insert',
    method: 'post',
    data: data,
  })
}
//作品搜索
export function getWordList (data) {
  return request({
    url: '/copyrightApi/reg/auth/v2/cr/reg/licensed/works/list',
    method: 'post',
    data: data,
  })
}
//获取详情
export function getRegisterDetail (params) {
  return request({
    url: '/copyrightApi/cr/new/details',
    method: 'get',
    params: params,
  })
}
//授权接口
export function consentToAuthorization (data) {
  return request({
    url: '/copyrightApi/reg/auth/v2/authorization/confirm',
    method: 'post',
    data: data,
  })
}
//签发证书
export function signAuthorization (data) {
  return request({
    url: '/copyrightApi/reg/auth/v2/formal/authorization',
    method: 'post',
    data: data,
  })
}
//签发证书
export function getGoodsList (data) {
  return request({
    url: '/copyrightApi/reg/auth/v2/works/list/authorized/v2',
    method: 'post',
    data: data,
  })
}
//查看作品
export function getGoodFile (data) {
  return request({
    url: '/copyrightApi/reg/auth/v2/works/file/list',
    method: 'post',
    data: data,
  })
}
//转让-提交审核
export function submitExamine (data) {
  return request({
    url: '/copyrightApi/copyright/examine/submit',
    method: 'post',
    data: data,
  })
}
//转让删除
export function deletebatchNo (data) {
  return request({
    url: 'copyrightApi/cr/new/delete',
    method: 'post',
    data: data,
  })
}

//资产发行提交审核接口
export function postSubmit (data) {
  return request({
    url: 'copyrightApi/examine/task/submit',
    method: 'post',
    data: data,
  })
}